export default {
  SEM_ACAO: 0,
  FOLLOW_UP: 1,
  PRODUTO: 2,
  RESPONSAVEL: 3,
  SERASA: 4,
  MOVIMENTACAO: 5,
  NOTIFICACAO: 6,
  ENVIO_WHATSAPP: 7,
  BLOQUEAR_AJUIZAMENTO: 8
}



// WEBPACK FOOTER //
// ./src/views/private/crm/board/modal/collumns/columnEvents.js